import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                笔趣阁
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              全网最速小说更新平台，同步作者最新章节，全文无删减，多端无缝阅读。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</Link>
              <Link to="/about" className="block text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">热门分类</h4>
            <div className="space-y-2">
              <Link to="/category/xuanhuan" className="block text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">玄幻奇幻</Link>
              <Link to="/category/wuxia" className="block text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">武侠仙侠</Link>
              <Link to="/category/dushi" className="block text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">都市言情</Link>
              <Link to="/category/lishi" className="block text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">历史军事</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系与声明</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              本站所有小说均由作者授权发布，版权归原作者所有。如有疑问请联系客服。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 笔趣阁. All rights reserved. 本站内容仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}